import { render } from "./AgregarCliente.vue?vue&type=template&id=1866e4e7"
import script from "./AgregarCliente.vue?vue&type=script&lang=js"
export * from "./AgregarCliente.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__